module.exports = __webpack_public_path__ + "assets/img/statis-failed.28030247.svg";